<template>
  <div class="container">
    <div class="mt-2 card">
      <!-- <table
        style="border: 1px solid #bbb; border-bottom: 4px solid black"
        class="table align-items-center mb-0"
      >
        <thead>
          <tr style="color: black">
            <th scope="col">Patient Name: Christopher Omwamba</th>
            <th scope="col">Age: 32yrs 6 months</th>
            <th scope="col">Gender: Male</th>
            <th scope="col">
              <button
                @click="handleShowAddTestModal"
                class="mycustom-success-button"
              >
                Add Prescription 
              </button>
            </th>
          </tr>
        </thead>
      </table> -->

      <PatientInfo v-if="patient_id != null" :patient_id="patient_id">
        <template v-slot:action-bt>
          <button
            @click="handleShowAddTestModal"
            class="mycustom-success-button"
          >
            Add Prescription
          </button>
        </template>
      </PatientInfo>
    </div>
  </div>

  <div class="container">
    <div class="mt-2 card parent-div">
      <table class="table align-items-center mb-0">
        <thead>
          <tr style="color: black">
            <th scope="col">Prescription Service ID</th>
            <th scope="col">Medicine/Item Name</th>
            <th scope="col">Dosage</th>
            <th scope="col">Instructions</th>
            <th scope="col">Quantity</th>
            <th scope="col">Status</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="prescription in prescriptions" :key="prescription.id">
            <th scope="row">{{ prescription.detail_id }}</th>
            <td style="color: black">
              <!-- {{ prescription.item_name }} -->
              <ItemName
                :ItemBrand="prescription.brand_name"
                :ItemStrength="prescription.strength"
                :ItemName="prescription.item_name"
              />
            </td>
            <td>{{ prescription.dosage }}</td>
            <td>{{ prescription.instructions }}</td>
            <td>{{ prescription.quantity }}</td>
            <td>{{ prescription.status == "0" ? "pending" : "issued" }}</td>
            <td>
              <button
                v-if="prescription.status == '0'"
                @click="deletePrescription(prescription.detail_id)"
                style="background-color: #f23678; color: white"
              >
                Delete prescription
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <AddPresModal
    v-if="show_add_lab_test_modal"
    @close-add-pres-modal="hideCreateTestModel"
    :store_id="2"
    :visit_id="visit_id"
    pres_type="out_prescription"
  />
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import AddPresModal from "./pharmacy/add_prescription_modal.vue";
import PatientInfo from "../Patients/components/patient_biodata.vue";
import ItemName from "../Inventory/components/ItemName.vue";

export default {
  name: "VisitsDashboard",
  data() {
    return {
      show_add_lab_test_modal: false,
      prescriptions: [],
      visit_id: this.$route.params.visitid,
      patient_id: null,
    };
  },
  components: {
    AddPresModal,
    PatientInfo,
    ItemName,
  },
  methods: {
    navigate_loc(route) {
      window.location.href = route;
    },
    handleShowAddTestModal() {
      this.show_add_lab_test_modal = true;
    },
    hideCreateTestModel() {
      this.show_add_lab_test_modal = false;
      this.callApi();
    },
    async callApi() {
      try {
        // const visit_id = this.$route.params.visit_id; // Assuming visit_id is in the URL params
        const url = `visit/prescriptions/${this.visit_id}`; // Adjust this based on your backend API route
        const data = await generalApiRequest(url, "GET", {}, true); // true for authFlag to pass JWT token automatically
        console.log(`visit/prescriptions/${this.visit_id}`);

        console.log(this.$route.params.visit_id);

        this.prescriptions = data.data;
      } catch (error) {
        console.error("Error fetching prescriptions:", error);
      }
    },
    async deletePrescription(id) {
      // try {
      const url = "delete_prescription";
      const body = {
        pres_details_id: id,
      };

      await generalApiRequest(url, "POST", body, 1);
      window.location.reload();
      // if (res) {
      //   this.callApi();
      // }
      // -------------------------------------
      // const url = `prescriptions/delete/${id}`;
      // const response = await generalApiRequest(url, "DELETE", {}, true); // Delete request
      // if (response.status === "success") {
      //   this.prescriptions = this.prescriptions.filter(
      //     (prescription) => prescription.id !== id
      //   );
      // }
      // } catch (error) {
      //   console.error("Error deleting prescription:", error);
      // }
    },

    async mountPastRecords() {
      const url = "get_all_visits_dates";
      const res = await generalApiRequest(
        url,
        "GET",
        { visit_id: this.visit_id },
        1
      );
      this.past_records = res.data;
      if (res.data.length > 0) {
        this.patient_id = res.data[0].patient_id;
      }
    },
  },
  mounted() {
    this.callApi();
    this.mountPastRecords();
  },
};
</script>

<style scoped>
.parent-div {
  width: 100%;
  overflow-x: auto;
}

.table {
  width: 100%;
  table-layout: auto;
  border-collapse: collapse;
}

.table td,
.table th {
  word-wrap: break-word;
  padding: 8px;
}

@media (max-width: 768px) {
  .table {
    font-size: 14px;
  }

  .table td,
  .table th {
    padding: 4px;
  }
}

.table th,
.table td {
  word-wrap: break-word; /* Allows text to wrap onto the next line */
  white-space: normal; /* Default behavior allows text to wrap */
  font-size: 0.8em;
  color: black;
}
</style>
